import { CellContext } from '@tanstack/react-table';
import { DropdownOptionDto } from '@/features/dashboard/tourCustomFields/types/DropdownCustomFieldDefinitionDto.ts';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';
import { CellChipList } from '@/components/table/_fieldDefinitions/_base/CellChipList.tsx';

export const dropdownFieldRender = <T,>(
  info: CellContext<T, unknown>,
  customFieldsContext?: { options: DropdownOptionDto[] },
) => {
  const value = info.getValue();
  if (value === null || value === undefined || value === '') {
    return <EmptyValue />;
  }
  if (customFieldsContext) {
    const optionId = value as string;
    const option = customFieldsContext.options.find(
      (opt) => opt.id === optionId,
    );
    return option ? option.label : optionId;
  }
  return value;
};

// todo refactor to exlude options rendered logic to seprate file and add proper dtos
export const dropdownFieldRenderOptions = <T,>(
  info: CellContext<T, unknown>,
  customFieldsContext?: { options: DropdownOptionDto[] },
) => {
  const optionIds = (info.getValue() as string[] | null | undefined) ?? [];
  if (optionIds.length === 0) {
    return <EmptyValue />;
  }

  const options = customFieldsContext?.options ?? [];
  return (
    <CellChipList
      items={optionIds.map((id) => ({
        key: id,
        label: options.find((opt) => opt.id === id)?.label ?? id,
      }))}
    />
  );
};
